module.exports = __webpack_public_path__ + "img/term-life-insurance.d4476da.png";